import { useMutation } from '@tanstack/react-query';

import { SystemComponentFormSchemaValues } from 'src/features/systems/utils/formSchema';
import { SystemComponent } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/system/component/:componentId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: SystemComponentFormSchemaValues;
    componentId: string;
    parkingId: string;
}
const mutationFn = ({ componentId, parkingId, data }: DTO): Promise<SystemComponent> => {
    return axios.put(formatResourcePath(RESOURCE, { componentId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateComponent };
